import prize1Src from "../../images/sweepstakes-prize-01.jpg";
import prize2Src from "../../images/sweepstakes-prize-02.jpg";
import prize3Src from "../../images/sweepstakes-prize-03.jpg";
import prize4Src from "../../images/sweepstakes-prize-04.jpg";
import prize5Src from "../../images/sweepstakes-prize-05.jpg";
import prize6Src from "../../images/sweepstakes-prize-06.jpg";

export const grandPrize = [
  {
    id: 1,
    image: prize1Src,
  },
  {
    id: 2,
    image: prize2Src,
  },
  {
    id: 3,
    image: prize3Src,
  },
  {
    id: 4,
    image: prize4Src,
  },
  {
    id: 5,
    image: prize5Src,
  },
  {
    id: 6,
    image: prize6Src,
  },
];

export const firstPrize = [
  {
    id: 1,
    image: prize3Src,
  },
  {
    id: 2,
    image: prize4Src,
  },
  {
    id: 3,
    image: prize5Src,
  },
  {
    id: 6,
    image: prize6Src,
  },
];

export const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 1200,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
};
